import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
  selector: 'era-device-mdm-sync-force-ui',
  templateUrl: './device-mdm-sync-force.component.html',
  styleUrls: ['./device-mdm-sync-force.component.scss'],
  imports: [ReactiveFormsModule, FormsModule],
})
export class DeviceMdmSyncForceComponent implements OnInit {
  @Input() public allowForce: boolean;
  @Output() public readonly forceSync = new EventEmitter<boolean>();

  public readonly forceSyncForm: UntypedFormControl = new UntypedFormControl(false);

  ngOnInit(): void {
    if (this.allowForce) {
      this.forceSyncForm.enable();
    } else {
      this.forceSyncForm.disable();
    }

    this.forceSyncForm.valueChanges.subscribe((value: boolean) => {
      this.forceSync.emit(value);
    });
  }
}
